import Vue from 'vue';
import FormAudioElement from './FormElements/FormAudioElement';
import FormAdvancedBarcodeElement from './FormElements/FormAdvancedBarcodeElement';
import FormBarcodeElement from './FormElements/FormBarcodeElement';
import FormCheckboxElement from './FormElements/FormCheckboxElement';
import FormDateElement from './FormElements/FormDateElement';
import FormFileElement from './FormElements/FormFileElement';
import FormGroupElement from './FormElements/FormGroupElement';
import FormGroupDuplicableElement from './FormElements/FormGroupDuplicableElement';
import FormImageDisplayElement from './FormElements/FormImageDisplayElement';
import FormImageElement from './FormElements/FormImageElement';
import FormInputElement from './FormElements/FormInputElement';
import FormLocationElement from './FormElements/FormLocationElement';
import FormMultiSelectElement from './FormElements/FormMultiSelectElement';
import FormPrioritizeElement from './FormElements/FormPrioritizeElement';
import FormScaleElement from './FormElements/FormScaleElement';
import FormScribbleElement from './FormElements/FormScribbleElement';
import FormSelectElement from './FormElements/FormSelectElement';
import FormSignatureElement from './FormElements/FormSignatureElement';
import FormTextElement from './FormElements/FormTextElement';

export default {
  name: 'FormElement',
  functional: true,
  props: {
    type: { type: String, required: true },
    options: { type: Object, required: true }
  },
  render: function (h, context) {
    function appropriateComponent () {
      const type = context.props.type;

      if (type === 'audio') return FormAudioElement;
      else if (type === 'advanced_barcode') return FormAdvancedBarcodeElement;
      else if (type === 'barcode') return FormBarcodeElement;
      else if (type === 'checkbox') return FormCheckboxElement;
      else if (type === 'date') return FormDateElement;
      else if (type === 'file') return FormFileElement;
      else if (type === 'form_group' && (!context.props.options || !context.props.options.duplicateable)) return FormGroupElement;
      else if (type === 'form_group' && context.props.options && context.props.options.duplicateable) return FormGroupDuplicableElement;
      else if (type === 'image_display') return FormImageDisplayElement;
      else if (type === 'image') return FormImageElement;
      else if (type === 'location') return FormLocationElement;
      else if (type === 'multi_select') return FormMultiSelectElement;
      else if (type === 'prioritize') return FormPrioritizeElement;
      else if (type === 'scale') return FormScaleElement;
      else if (type === 'scribble') return FormScribbleElement;
      else if (type === 'select') return FormSelectElement;
      else if (type === 'signature') return FormSignatureElement;
      else if (type === 'text') return FormTextElement;
      else return FormInputElement;
    }

    context.data.attrs.type = context.props.type;
    context.data.attrs.options = context.props.options;

    return h(appropriateComponent(), context.data, context.children);
  }
};
